export const Config = {
    GOOGLEMAPAPIKEY: 'AIzaSyC2vwoyuIB_jYngpeA4hfD5U_0k6wUq2yk',
    API: 'https://wsdcourierservices.co.uk/api',
    GA: 'UA-145318802-1',
    PAYPALCLIENTID: 'AUl1XueBJIIKlwnK3GsN55JHa2IAw3ESQf6TN_KzSUeguoU5tL7gZk1JtYan35xZcmu59OQio_piQI-m',
    DEFAULTPAYMENT: 10
};